var React = require('react');

function Hamburger (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Combined Shape"),React.createElement("g",{"id":"//-Symbols","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round","key":1},React.createElement("g",{"id":"icons/Navigation/Menu-Light","transform":"translate(-3.000000, -5.000000)","stroke":"#FFFFFF","strokeWidth":"2"},React.createElement("path",{"d":"M20,6 L4,6 M20,12 L4,12 M20,18 L4,18","id":"Combined-Shape"})))]);
}

Hamburger.defaultProps = {"width":"18px","height":"14px","viewBox":"0 0 18 14","version":"1.1"};

module.exports = Hamburger;

Hamburger.default = Hamburger;
